import { keyMap } from '@locales/lokalise/keyMap';
import { navigateToURL } from '@utils/navigateToURL';
import { NotificationDialog } from 'components/shared/modal';
import { IUser } from 'global.interfaces';
import i18next from 'i18next';
import { mobxStore } from 'store/mobx';
import { isInRole, isSignedIn } from 'utils/userPermissions';

export { UserPermissionsHandler, showForbiddenNotificationDialog };

enum PermissionState {
  NotSignedIn = 1,
  NotInRole = 2,
  HasAccess = 3,
}

interface IResponseError {
  config: {
    url: string;
  };
  status: number;
}

class UserPermissionsHandler {
  private state: PermissionState;

  private handlers = new Map<PermissionState, () => void>([
    [
      PermissionState.HasAccess,
      () => {
        void 0;
      },
    ],
    [PermissionState.NotInRole, showNoPermissionNotificationDialog],
    [PermissionState.NotSignedIn, mobxStore.authStore.signOutAndShowSessionExpiredNotificationDialog],
  ]);

  constructor(user: IUser | null | Record<string, never>, role: string) {
    if (!isSignedIn(user)) {
      this.state = PermissionState.NotSignedIn;
      return;
    }

    if (!isInRole(user, role)) {
      this.state = PermissionState.NotInRole;
      return;
    }

    this.state = PermissionState.HasAccess;
  }

  public showNotification(): void {
    this.handlers.get(this.state)?.();
  }

  public hasPermission(): boolean {
    return this.state === PermissionState.HasAccess;
  }
}

function showNoPermissionNotificationDialog(): void {
  NotificationDialog.show(keyMap.sharedSystemNoPermissionToAccessSection, 'error');

  setTimeout(function () {
    navigateToURL('/');
  }, 500);
}

function showForbiddenNotificationDialog(response: IResponseError): void {
  const paths = response.config.url.split('?')[0].split('.');

  const controller = paths.length >= 2 ? paths[paths.length - 2] : '';
  const action = paths.length >= 1 ? paths[paths.length - 1] : '';

  NotificationDialog.show(i18next.t(keyMap.sharedSystemError403, { controller, action }), 'error');
}
